import { CommonModule } from '@angular/common';
import { Component, input, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-empty-table',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './empty-table.component.html',
  styleUrl: './empty-table.component.scss'
})
export class EmptyTableComponent {
  @Input() emptyMessage: string;
  @Input() isSearching: boolean;
  @Input() keyword: string;
}
